import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import type { IProject } from '@/types';
import { deleteProject, getProjectList, pinnedProject, unPinnedProject } from '@/infrastructure/api-functions';

export function useProjectList() {
    const projects = ref<IProject[]>([])

    const isEmpty = computed(() => {
        return projects.value.length === 0;
    })

    const getProjectListLoading = ref(false)

    const router = useRouter()

    function createProject() {
        router.push('chat');
    }

    function getList() {
        getProjectListLoading.value = true;
        getProjectList().then((res) => {
            projects.value = res.project_list
        }).finally(() => {
            getProjectListLoading.value = false;
        })
    }

    async function pinProject(id: string) {
        projects.value.forEach(p => { p.pinned = false })
        const project = projects.value.find((p) => p.project_id === id)
        if (project && !project.pinned) {
            await pinnedProject(id)
            project.pinned = true
            projects.value = [project, ...projects.value.filter((p) => p.project_id !== id)]
        }
    }

    async function unpinProject(id: string) {
        await unPinnedProject(id)
        getList();
    }

    async function removeProject(id: string) {
        await deleteProject(id)
        projects.value = projects.value.filter((p) => p.project_id !== id)
    }

    onMounted(() => {
        getList();
    })

    return {
        getProjectListLoading,
        isEmpty,
        projects,
        createProject,
        removeProject,
        pinProject,
        unpinProject,
    }
}
